import React from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/components/App/App';

import './sass/main.scss';

createRoot(document.getElementById('root')!)
  .render(<App />);
